// extracted by mini-css-extract-plugin
export default {"root":"FavouriteButton-module-root","asLink":"FavouriteButton-module-asLink","favouriteCount":"FavouriteButton-module-favouriteCount"};